import React from 'react';

export function AttestationCardFallback() {
    return (
        <div className="gap-card risk-gap-card col-12 col-md-6 col-lg-4">
            <div className="card mb-2 border-dark">
                <div className="card-body border-dark">
                    <div className="row">
                        <div className="col-9 action-container">
                            <div className="row title">
                                <div className="col-4 d-inline-flex">
                                    <span />
                                </div>
                                <div className="col text-truncate" title="" />
                            </div>
                            <div className="row">
                                <div className="col">
                                    <i>Sorry, we encountered an error on this attestation.</i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
